import { Box, Tab, Tabs } from "@mui/material";
import { SyntheticEvent, useContext, useEffect } from "react";
import { NumberParam, StringParam, useQueryParam } from "use-query-params";
import { UserContext } from "../../contexts/UserContext";
import MatchResolutionRequestsTab from "../MatchResolution/MatchResolutionRequestsTab";
import { BlacklistEntityType } from "../types";
import CompanyRecordsTab from "./Tabs/CompanyRecordsTab";
import PersonRecordsTab from "./Tabs/PersonRecordsTab";
import PropertyRecordsTab from "./Tabs/PropertyRecordsTab";

const usersToEdit = [
  "agoldstein@madisoncres.com",
  "sdavidowitz@madisoncres.com",
  "mgersten@madisoncres.com",
  "afriedman@madisoncres.com",
  "bfreylicher@madisoncres.com",
  "swaldman@madisoncres.com",
  "egoichman@madisontitle.com",
  "hoppenheim@madisontitle.com",
  "mstern@madisontitle.com",
  "ymeister@madisontitle.com",
  "leahb@madisontitle.com",
  "dklein@madisontitle.com"
];

const matchResolutionRequestsTab = 4;

const ViewBulletins = () => {
  const { user } = useContext(UserContext);
  const [selectedEntityId, setSelectedEntityId] = useQueryParam("entityId", StringParam);
  const [selectedEntityType, setSelectedEntityType] = useQueryParam("entityType", NumberParam);
  const [selectedMatchResolutionRequestId, setSelectedMatchResolutionRequestId] = useQueryParam("matchResolutionRequestId", StringParam);

  const canEdit = usersToEdit.includes(user?.email?.toLowerCase() ?? "");

  useEffect(() => {
    if (selectedEntityType === null || selectedEntityType === undefined) {
      setSelectedEntityType(BlacklistEntityType.Person);
    }
  }, [selectedEntityType]);

  useEffect(() => {
    if (selectedMatchResolutionRequestId && selectedEntityType !== matchResolutionRequestsTab) {
      setSelectedEntityType(matchResolutionRequestsTab);
    }
  }, [selectedMatchResolutionRequestId, selectedEntityType]);

  const onEditPerson = canEdit ? (entityId: number) => window.open(`/edit-blacklist-name?entityId=${entityId}&entityType=${BlacklistEntityType.Person}`, "_blank") : undefined;
  const onEditCompany = canEdit ? (entityId: number) => window.open(`/edit-blacklist-name?entityId=${entityId}&entityType=${BlacklistEntityType.Company}`, "_blank") : undefined;
  const onEditProperty = canEdit ? (entityId: number) => window.open(`/edit-blacklist-property?entityId=${entityId}`, "_blank") : undefined;
  const handleTabChange = (_: SyntheticEvent, newValue: number) => {
    if (newValue !== matchResolutionRequestsTab) {
      setSelectedMatchResolutionRequestId(undefined);
    }

    setSelectedEntityType(newValue);
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Tabs
        value={selectedEntityType}
        onChange={handleTabChange}
        aria-label="blacklistTabs"
      >
        <Tab label="Individual" value={BlacklistEntityType.Person} />
        <Tab label="Entity" value={BlacklistEntityType.Company} />
        <Tab label="Property" value={BlacklistEntityType.Property} />
        <Tab label="Resolved Contacts" value={matchResolutionRequestsTab} />
      </Tabs>

      <Box sx={{ mt: 2 }}>
        {selectedEntityType === BlacklistEntityType.Person && (
          <PersonRecordsTab
            setSelectedEntityId={setSelectedEntityId}
            selectedEntityId={selectedEntityId ? Number(selectedEntityId) : undefined}
            onEdit={onEditPerson}
          />
        )}
        {selectedEntityType === BlacklistEntityType.Company && (
          <CompanyRecordsTab
            setSelectedEntityId={setSelectedEntityId}
            selectedEntityId={selectedEntityId ? Number(selectedEntityId) : undefined}
            onEdit={onEditCompany}
          />
        )}
        {selectedEntityType === BlacklistEntityType.Property && (
          <PropertyRecordsTab
            setSelectedEntityId={setSelectedEntityId}
            selectedEntityId={selectedEntityId ? Number(selectedEntityId) : undefined}
            onEdit={onEditProperty}
          />
        )}
        {selectedEntityType === matchResolutionRequestsTab && (
          <MatchResolutionRequestsTab
            selectedRequestId={selectedMatchResolutionRequestId ? Number(selectedMatchResolutionRequestId) : undefined}
            setSelectedRequestId={setSelectedMatchResolutionRequestId}
          />
        )}
      </Box>
    </Box>
  );
};

export default ViewBulletins;
